<template>
  <div class="plan-list">
    <QueryFrame
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'
      addText=""
      :count='count'
      :current="page"
    >
      <div slot="queryParams">
        <div class="queryContainer">
          <div class="queryItem">
            <label>门店名称:</label>
            <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
          </div>
          <div class="queryItem" >
            <label>状态:</label>
            <lk-select
              class="item"
              v-model="query.status"
              clearable
            >
              <lk-option
                v-for="(item, index) in publicParams.searchStatus"
                :value='item.id'
                :key="index"
              >{{item.name}}</lk-option>
            </lk-select>
         </div>
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <lk-table
          border
          :columns='columns'
          :data='tableData'
          ></lk-table>
      </div>
    </QueryFrame>
    <DTPModal
      v-model="showModal"
      @confirm='confirmEdit'
      @handleCancel='confirmClear'
      :content='Modalcontent'
    ></DTPModal>
    <lk-modal
      draggable
      scrollable
      v-model="modifiedModal"
      @on-ok='handlerInputOk'
      @on-cancel='handlerInputCancel'
      title="修改顺丰id">
      <label>顺丰门店id: </label>
      <lk-input
        style="width: 300px"
        placeholder="请输入"
        v-model="modifiedIdParams.sfCode"
      />
    </lk-modal>
  </div>
</template>
<script>
import QueryFrame from '@/components/frame/QueryFrame.vue';
import sf from '@/services/sf';
import utils from '@/libs/utils';
import mapState from '@/mixins/mapState';
import queryMixins from '@/mixins/queryMixins';
import DTPModal from '@/components/DTPModal';

export default {
  name: 'SFGoodsMangement',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
    DTPModal,
  },
  data() {
    return {
      modifiedIdParams: { // 修改顺丰id params
        sfCode: '',
        storeId: '',
        storeName: '',
      },
      updateStatusPatams: { // 修改状态 params
        storeId: '',
        storeName: '',
        sfCode: '',
        status: '', // 改为启用状态-1；改为关闭状态-传2
      },
      tempSFStoreId: '', // 修改顺丰id的门店id
      showModal: false,
      modifiedModal: false,
      Modalcontent: '',
      query: {
        storeIdList: [],
      },
      columns: [
        {
          title: '序号',
          key: 'index',
          minWidth: 58,
          render: (h, { index }) => h('span', index + 1),
        },
        {
          title: '门店名称',
          minWidth: 116,
          key: 'storeName',
        },
        {
          title: '状态',
          minWidth: 116,
          key: 'status',
          render: (h, { row }) => h('span', row.status
            ? this.publicParams.searchStatus.filter(item => item.id === row.status)[0].name
            : ''),
        },
        {
          title: '顺丰门店id',
          minWidth: 116,
          key: 'sfCode',
        },
        {
          title: '对接商品数量',
          minWidth: 116,
          key: 'dockedGoodsNum',
        },
        {
          title: '最后修改时间',
          minWidth: 116,
          key: 'modifiedTime',
          render: (h, { row }) => h('span', row.modifiedTime
            ? utils.formatDateToSecond(row.modifiedTime)
            : ''),
        },
        {
          title: '操作',
          minWidth: 116,
          render: (h, { row }) => h('div', [
            this.handlePermission('sfConfigEdit') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.modifiedModal = true;
                  this.modifiedIdParams.storeId = row.storeId;
                  this.modifiedIdParams.storeName = row.storeName;
                  this.modifiedIdParams.sfCode = row.sfCode;
                },
              },
            }, '修改顺丰id') : null,
            this.handlePermission('sfConfigEditStatus') && row.status === 2 ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.handlerStatus(1, row.storeId, row.storeName, row.sfCode);
                },
              },
            }, '启用') : null,
            this.handlePermission('sfConfigEditStatus') && row.status === 1 ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.handlerStatus(2, row.storeId, row.storeName, row.sfCode);
                },
              },
            }, '停用') : null,
          ]),
        },
      ],
      tableData: [],
    };
  },
  methods: {
    handlerInputOk() {
      this.handlerUpdate(this.modifiedIdParams);
    },
    handlerInputCancel() {
      this.modifiedIdParams = {
        sfCode: '',
        storeId: '',
        storeName: '',
      };
    },
    handlerStatus(status, storeId, storeName, sfCode) {
      if (status === 2) {
        this.Modalcontent = '是否停用该门店';
      } else {
        this.Modalcontent = '是否启用该门店';
      }
      this.updateStatusPatams.storeId = storeId;
      this.updateStatusPatams.status = status;
      this.updateStatusPatams.storeName = storeName;
      this.updateStatusPatams.sfCode = sfCode;
      this.showModal = true;
    },
    handlerUpdate(params) {
      sf.updateStatus(params).then((res) => {
        if (res.data.status === 200) {
          this.getData();
        } else {
          this.getData();
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        this.getData();
        utils.handleError(err);
      });
    },
    confirmClear() {
      this.updateStatusPatams = {
        storeId: '',
        storeName: '',
        sfCode: '',
        status: '',
      };
    },
    confirmEdit() {
      this.showModal = false;
      this.handlerUpdate(this.updateStatusPatams);
    },
    clear() {
      this.page = 1;
      this.size = 20;
      this.query = {
        storeIdList: [],
      };
    },
    getData() {
      const params = utils.deepClone(this.query);
      params.page = this.page;
      params.size = this.size;
      sf.listSfGoodsConfigList(params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          this.count = res.data.data.count;
          this.tableData = res.data.data.list;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  mounted() {
    this.handleSearch(true);
  },
};
</script>
<style lang="less" scoped>
</style>
